import * as React from 'react';
import { observer } from 'mobx-react';

import './RewardsPage.pcss';
import {computed, observable} from "mobx";
import {milestonesDataSource} from "../data/MilestonesDataSource";
import {PageEnum} from "./nav/PageEnums";
import {PageWrapper} from "./widgets/PageWrapper";
import {IEarnedPointDesc} from "../data/PointsDataSource";
import {UIState} from "../data/UIState";


interface Props {
	nav:any;
}

@observer
export class RewardsPage extends React.Component<Props> {
	@observable milestones:Array<any> = [];

	componentDidMount() {
		milestonesDataSource.addListener(this.handleMilestonesDataChange);
		this.handleMilestonesDataChange();
	}

	componentWillUnmount() {
		milestonesDataSource.removeListener(this.handleMilestonesDataChange);
	}

	handleMilestonesDataChange = () => {
		this.milestones = milestonesDataSource.getMilestones();
	}

	@computed
	get feedItems() {
		let feedItems = [];
		this.milestones.forEach((milestone)=>{
			feedItems = feedItems.concat(milestone.feedItems);
		});
		return feedItems;
	}

	render() {
		// const {solution} = this.props;

		const solution = UIState.feedData.solution;

		// const pageEnum = new PageEnum(PageEnums.prizes.name, (solution.prizesPageName?solution.prizesPageName:PageEnums.prizes.title));
		const pageEnum = new PageEnum("prizes");

		return (
			<div className={"outside voice"}>
				{this.props.nav}
				<PageWrapper pageEnum={pageEnum} noPadding>
					<div className={"head"}>
						<div className={"section-container"}>
							<h2 className={'level2'}>You've earned <span className="points">{UIState.feedData.pointsDataSource.points}</span> points</h2>
							<p>{solution.prizesDescription}</p>
						</div>
					</div>

					<div className={"section-container"}  role="list" aria-label={'Prizes'}>
						{solution.prizes.map((prize, idx) => {
							const prizeTitle = prize.prizeTitle ? prize.prizeTitle +": "+ prize.what : prize.what;
							return (
								<div className={"prize"} style={{display: 'flex'}} key={idx} role="listitem" aria-label={`Prize: ${prizeTitle}`}>
									<div><img src={prize.image} aria-hidden /></div>
									<div>
										<h3 className={'level3'}>{prizeTitle}</h3>
										<p className={'how'}>{prize.how}</p>
										<p className={'when'}>{prize.when}</p>
									</div>
								</div>
							);
						})}
					</div>

					<div className="section-container healthFairPoints">
						<h3 className={'level3'} aria-hidden>Your points earned</h3>
						{0 === UIState.feedData.pointsDataSource.earnedPointDescriptions.length ?
							<div className={"desc"}>No points yet earned.</div>
							:
							<div role="list" aria-label={'points earned'}>
								{UIState.feedData.pointsDataSource.earnedPointDescriptions.map((earnedPointDesc: IEarnedPointDesc) =>
									<div role="listitem" key={earnedPointDesc._id}>
										<span className={'visuallyhidden'}>{earnedPointDesc.pointsAwarded} point{earnedPointDesc.pointsAwarded!==1?'s':''} for {earnedPointDesc.name}</span>
										<div className={"desc"} key={earnedPointDesc._id} aria-hidden>
											<div>
												<i aria-hidden className={earnedPointDesc.icon}></i>
												{earnedPointDesc.name}
											</div>
											<div>
												<i className={"fa fa-plus"}></i>
												<div className="circ">{earnedPointDesc.pointsAwarded}</div>
											</div>
										</div>
									</div>
								)
								}

							</div>
						}
					</div>

				</PageWrapper>
			</div>
		);
	}
}



